module.exports = __webpack_public_path__ + "img/text-image.5d3f8fba.jpg";